<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >头条管理</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    clearable
                                    placeholder="请输入内容"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="是否启用"
                            field="Enabled"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select v-model="data.Enabled" clearable>
                                    <vxe-option
                                        value="0"
                                        label="否"
                                    ></vxe-option>
                                    <vxe-option
                                        value="1"
                                        label="是"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                                <vxe-button status="success" @click="add"
                                    >新增</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        class="mytable-scrollbar"
                        ref="table"
                        :data="tableData"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="60"
                        ></vxe-column>
                        <vxe-column title="编辑" width="60" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-edit"
                                    @click="editNews(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="删除" width="60" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-trash-o"
                                    @click="removeNews(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="Title"
                            title="标题"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="Seq"
                            title="排序"
                            width="80"
                        ></vxe-column>
                        <vxe-column
                            field="activeName"
                            title="是否启用"
                            width="100"
                        ></vxe-column>
                        <vxe-column
                            field="creatorName"
                            title="创建人"
                            width="100"
                        ></vxe-column>
                        <vxe-column
                            field="creationDate"
                            title="创建时间"
                            width="160"
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
            <vxe-modal
                :title="formInput.title"
                v-model="formInput.isShow"
                width="800"
                height="350"
            >
                <template #default>
                    <div>
                        <vxe-form
                            :data="formInput.formData"
                            :rules="formInput.formRules"
                            ref="rForm"
                            title-align="right"
                        >
                            <vxe-form-item
                                title="头条标题"
                                field="Title"
                                span="14"
                                :item-render="{}"
                                title-width="100px"
                            >
                                <template #default="{ data }">
                                    <vxe-input
                                        v-model="data.Title"
                                        placeholder="请输入头条标题"
                                        clearable
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="排序"
                                field="Seq"
                                span="5"
                                :item-render="{}"
                            >
                                <template #default="{ data }">
                                    <vxe-input
                                        v-model="data.Seq"
                                        placeholder="请输入排序"
                                        clearable
                                        type="number"
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="是否显示"
                                field="Enabled"
                                span="5"
                                :item-render="{}"
                            >
                                <template #default="{ data }">
                                    <vxe-select
                                        v-model="data.Enabled"
                                        clearable
                                    >
                                        <vxe-option
                                            value="0"
                                            label="否"
                                        ></vxe-option>
                                        <vxe-option
                                            value="1"
                                            label="是"
                                        ></vxe-option>
                                    </vxe-select>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="封面"
                                field="Cover"
                                title-align="right"
                                span="14"
                                :item-render="{}"
                                title-width="100px"
                            >
                                <template #default="{ data }">
                                    <vxe-input
                                        v-model="data.Cover"
                                        placeholder="请选择文件"
                                        readonly
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item title="" span="2" :item-render="{}">
                                <template #default="">
                                    <vxe-button @click="insertEvent"
                                        >浏览</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item title="" span="6" :item-render="{}">
                                <a
                                    v-if="isShowLink"
                                    href="javascript:void(0);"
                                    @click="downloadFile"
                                    >下载</a
                                >
                            </vxe-form-item>
                            <vxe-form-item
                                title="链接地址"
                                field="Url"
                                span="24"
                                title-width="100px"
                            >
                                <vxe-input
                                    v-model="formInput.formData.Url"
                                    placeholder="请输入链接地址"
                                ></vxe-input>
                            </vxe-form-item>
                            <vxe-form-item
                                title="备注"
                                field="Remark"
                                span="24"
                                title-width="100px"
                            >
                                <vxe-textarea
                                    v-model="formInput.formData.Remark"
                                    placeholder="请输入备注"
                                    maxlength="500"
                                    show-word-count
                                ></vxe-textarea>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                    <div
                        style="
                            width: 780px;
                            text-align: right;
                            height: 50px;
                            position: absolute;
                            bottom: 2px;
                            padding-right: 20px;
                        "
                    >
                        <vxe-button status="primary" @click="save"
                            >保存</vxe-button
                        >
                    </div>
                </template>
            </vxe-modal>
        </va-card-content>
    </va-card>
</template>

<script setup>
import Qs from "qs";
import {
    reactive,
    ref,
    onMounted,
    onUnmounted,
    getCurrentInstance,
    computed,
} from "vue";
import VXETable from "vxe-table";
const { proxy } = getCurrentInstance();
const tableHeight = ref(window.innerHeight - (65 + 28 + 198));
const isShowLink = ref(false);
const tablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
});
const toolbar = reactive({
    loading: false,
    formData: {
        searchKey: "",
        Enabled: "",
    },
});

const formInput = reactive({
    isShow: false,
    editType: "1",
    title: "新增头条",
    formRules: {
        Title: [{ required: true, message: "请输入头条标题" }],
        Enabled: [{ required: true, message: "请选择是否启用" }],
        Url: [{ required: true, message: "请输入链接地址" }],
        Cover: [{ required: true, message: "请选择封面" }],
        Seq: [{ required: true, message: "请输入排序" }],
    },
    formData: {
        Id: "",
        Title: "",
        Url: "",
        Seq: "",
        Cover: "",
        Remark: "",
        Enabled: "",
        creator: "",
        modifier: "",
    },
});

const add = () => {
    isShowLink.value = false;
    formInput.isShow = true;
    formInput.editType = "1";
    formInput.title = "新增头条";
    formInput.formData = {
        Id: "",
        Title: "",
        Url: "",
        Seq: "",
        Remark: "",
        Enabled: "1",
        creator: proxy.$store.state.userID,
        modifier: proxy.$store.state.userID,

    };
};
const editNews = (row) => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 20,
        searchKey: [row.Id],
    };
    formInput.isShow = true;

    proxy.$api.systemManageAPI
        .getNewsOne(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            formInput.title = "编辑头条";
            formInput.isShow = true;
            formInput.editType = "2"; //更新
            formInput.formData = res.data.Data[0];
            isShowLink.value = true;
            oneFile = null;
        })
        .catch((error) => {
            console.log(error);
        });
};
const removeNews = async (row) => {
    const type = await VXETable.modal.confirm("您确定要删除该数据?");
    const $grid = proxy.$refs.table;
    const params = {
        Id: row.Id,
    };
    if (type === "confirm") {
        proxy.$api.systemManageAPI
            .deleteNews(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success === false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "删除成功",
                    status: "success",
                });
                $grid.remove(row);
            })
            .catch((error) => {
                console.log(error);
            });
    }
};
let oneFile = null;
const insertEvent = async () => {
    const { files } = await VXETable.readFile(false);
    Array.from(files).map((file) => {
        formInput.formData.Cover = file.name;
        oneFile = file;
    });
};
const rForm = ref(null);
const save = async () => {
    const $rForm = rForm.value;
    const formErrMap = await $rForm.validate();
    if (formErrMap) {
        return;
    }

    const data = new FormData();
    data.append("file", oneFile);
    data.append("Id", encodeURIComponent(formInput.formData.Id));
    data.append("Title", encodeURIComponent(formInput.formData.Title));
    data.append("Enabled", encodeURIComponent(formInput.formData.Enabled));
    data.append("Url", encodeURIComponent(formInput.formData.Url));
    data.append("creator", encodeURIComponent(formInput.formData.creator));
    data.append("modifier", encodeURIComponent(formInput.formData.modifier));
    data.append("Remark", encodeURIComponent(formInput.formData.Remark));
    data.append("Cover", encodeURIComponent(formInput.formData.Cover));
    data.append("Seq", encodeURIComponent(formInput.formData.Seq));

    //新增
    if (formInput.editType === "1") {
        proxy.$api.systemManageAPI
            .addNews(data)
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
                formInput.isShow = false;
                isShowLink.value = true;
                findData();
            })
            .catch((error) => {
                VXETable.modal.alert({ content: error, status: "error" });
                console.log(error);
            });
    } else if (formInput.editType === "2") {
        //更新
        proxy.$api.systemManageAPI
            .updateNews(data)
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
                formInput.isShow = false;
                isShowLink.value = true;
                findData();
            })
            .catch((error) => {
                VXETable.modal.message({ content: error, status: "error" });
                console.log(error);
            });
    }
};
const calTableHeight = (rowsLength) => {
    let minHeight = window.innerHeight - (65 + 28 + 198);
    let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
    tableHeight.value = Math.max(minHeight, calHeight);
};
let tableData = ref([]);

const findData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: tablePager.currentPage,
        pageSize: tablePager.pageSize,
        searchKey: [toolbar.formData.searchKey, toolbar.formData.Enabled],
    };
    proxy.$api.systemManageAPI
        .getNewsList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "warning",
                });
                return;
            }
            // console.log(res.data.Data);
            tableData.value = res.data.Data.dataTable;
            tablePager.currentPage = res.data.Data.currentPage;
            tablePager.pageSize = res.data.Data.pageSize;
            tablePager.totalResult = res.data.Data.totalResult;
            calTableHeight(res.data.Data.dataTable.length);
        })
        .catch((error) => {
            console.log(error);
        });
};
const downloadFile = () => {
    proxy.$api.fileManageAPI
        .downloadNewsCover(Qs.stringify({ Id: formInput.formData.Id }))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }

            window.open(res.data.Data, "_blank").location;
        })
        .catch((error) => {
            console.log(error);
        });
};
const handlePageChange = () => {
    findData();
};
const clear = () => {
    toolbar.formData.searchKey = "";
    toolbar.formData.Enabled = "";
};
const keydown = (e) => {
    if (e.keyCode === 13) {
        findData();
    }
};
onMounted(() => {
    findData();
    formInput.formData.creator = proxy.$store.state.userID;
    formInput.formData.modifier = proxy.$store.state.userID;
    window.addEventListener("keydown", keydown);
});
onUnmounted(() => {
    window.removeEventListener("keydown", keydown, false);
});
</script>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
